import { render, staticRenderFns } from "./assetfrm.vue?vue&type=template&id=bd2f0c88"
import script from "./assetfrm.vue?vue&type=script&lang=js"
export * from "./assetfrm.vue?vue&type=script&lang=js"
import style0 from "./assetfrm.vue?vue&type=style&index=0&id=bd2f0c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports